import { VdrEnvironment } from '../data/models';

declare global {
  interface Window {
    readonly environment: VdrEnvironment;
  }
}

export const environment: VdrEnvironment = window.environment;
